/**
 * 🏛️ 馆藏级地质学术术语库 (Museum-Grade Lexicon Module)
 * 目标：强制约束大模型的输出文风，使用顶尖地质博物馆的规范术语，取代大模型自发的口语化描述。
 * 知识来源：参考香港大学许士芬等权威地质学博物馆标准描述。
 */
export const LEXICON_LOGIC = {
//
  academicLexicon: `
  === 🏛️ 学术报告词汇约束协议 (Academic Lexicon Enforcement) ===
  **核心指令**: 在填充 'detailedDescription', 'colorCause', 'textureAndStructure' 等描述性长文本字段时，你【必须】禁用日常口语，强制使用以下博物馆标准的规范术语：

  [1. 光泽描述准则 (Luster)]
  - 严禁使用：“反光”、“发亮”、“亮闪闪”。
  - 必须使用：
    - 【玻璃光泽 (Vitreous)】: 像玻璃一样的反光 (如石英、长石)。
    - 【油脂光泽 (Greasy)】: 像表面涂了油 (如断口处的石英、橄榄石、霞石)。
    - 【金属光泽 (Metallic)】: 像金属的强反光 (如黄铁矿、方铅矿)。
    - 【金刚光泽 (Adamantine)】: 极其璀璨夺目 (如钻石、闪锌矿)。
    - 【丝绢光泽 (Silky)】: 像绸缎一样，通常平行纤维排列 (如绢云母、石棉)。
    - 【珍珠光泽 (Pearly)】: 往往出现在平坦的解理面上 (如白云母、解理面上的长石)。

  [2. 破型/外表描述准则 (Fracture & Habit)]
  - 严禁使用：“一道道痕迹”、“像碎玻璃”、“一块一块的”。
  - 必须使用：
    - 【阶梯状解理 (Stepped Cleavage)】: 非常规则的台阶断口 (如方铅矿、方解石)。
    - 【贝壳状断口 (Conchoidal Fracture)】: 像贝壳表面的同心圆弧形纹 (如石英、黑曜岩、燧石)。
    - 【土状断口 (Earthy)】: 松散、无光泽的粗糙面 (如高岭土、铝土矿)。
    - 【放射状/针状结晶 (Radiating/Acicular)】: 向外散射的细长晶体。
    - 【胶状/葡萄状构造 (Botryoidal/Colloform)】: 像一串葡萄一样的表面 (如孔雀石、赤铁矿、褐铁矿)。

  [3. 变质与构造描述准则 (Metamorphic Structure)]
  - 严禁使用：“有纹理”、“一层一层的条纹”、“花纹”。
  - 必须使用：
    - 若为片状矿物定向排列，使用【片理构造 (Schistosity)】。
    - 若有显著的成分交替条带（黑白相间），使用【片麻状构造 (Gneissose)】。
    - 若有极其密集的微细破裂面，使用【劈理 (Cleavage) / 千枚状构造 (Phyllitic)】。

  [4. 风格声明]
  - 你的描述语气必须客观、冷峻。
  - 要像陈列在一流自然历史真品柜里的“展陈双语解说牌”。让阅读这份报告的人确信这是一份出自一流研究型大学地学联合实验室的严谨科研分析。
  `
};
